import { Action } from '@ngrx/store';

import { ReadingListDetails } from '®shared/reading-list/models';

export enum ListResolverStoreActionTypes {
  CLEAR_DRAFT_AND_PUBLISHED = '[List Resolver Store] Clear storage for a list',
  LIST_RESOLVER_STORE_DRAFT_REQUESTED = '[List Resolver Store] Draft list requested',
  LIST_RESOLVER_STORE_DRAFT_LOADED = '[List Resolver Store] Draft list loaded',
  LIST_RESOLVER_STORE_DRAFT_LOADING_FAILED = '[List Resolver Store] Draft list loading failed',
  LIST_RESOLVER_STORE_PUBLISHED_REQUESTED = '[List Resolver Store] Published list requested',
  LIST_RESOLVER_STORE_PUBLISHED_LOADED = '[List Resolver Store] Published list loaded',
  LIST_RESOLVER_STORE_PUBLISHED_LOADING_FAILED = '[List Resolver Store] Published list loading failed',
  CLEAR_ALL_LISTS = '[List Resolver Store] Clear all lists in storage',
}

export interface ListIdPayload {
  listId: string;
}

export interface ListResolverStoreLoadedPayload extends ListIdPayload {
  list: ReadingListDetails;
}

export interface ListResolverStoreLoadingFailedPayload extends ListIdPayload {
  error: any;
}

export class ClearDraftAndPublishedListsAction implements Action {
  readonly type = ListResolverStoreActionTypes.CLEAR_DRAFT_AND_PUBLISHED;

  constructor(public payload: ListIdPayload) {}
}

export class ClearAllListsAction implements Action {
  readonly type = ListResolverStoreActionTypes.CLEAR_ALL_LISTS;
}

export class DraftReadingListRequestedAction implements Action {
  readonly type =
    ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_REQUESTED;

  constructor(public payload: ListIdPayload) {}
}

export class DraftReadingListLoadedAction implements Action {
  readonly type = ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_LOADED;

  constructor(public payload: ListResolverStoreLoadedPayload) {}
}

export class DraftReadingListLoadingFailedAction implements Action {
  readonly type =
    ListResolverStoreActionTypes.LIST_RESOLVER_STORE_DRAFT_LOADING_FAILED;

  constructor(public payload: ListResolverStoreLoadingFailedPayload) {}
}

export class PublishedReadingListRequestedAction implements Action {
  readonly type =
    ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_REQUESTED;

  constructor(public payload: ListIdPayload) {}
}

export class PublishedReadingListLoadedAction implements Action {
  readonly type =
    ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_LOADED;

  constructor(public payload: ListResolverStoreLoadedPayload) {}
}

export class PublishedReadingListLoadingFailedAction implements Action {
  readonly type =
    ListResolverStoreActionTypes.LIST_RESOLVER_STORE_PUBLISHED_LOADING_FAILED;

  constructor(public payload: ListResolverStoreLoadingFailedPayload) {}
}

export type ListResolverStoreActions =
  | ClearAllListsAction
  | ClearDraftAndPublishedListsAction
  | DraftReadingListRequestedAction
  | DraftReadingListLoadedAction
  | DraftReadingListLoadingFailedAction
  | PublishedReadingListRequestedAction
  | PublishedReadingListLoadedAction
  | PublishedReadingListLoadingFailedAction;
